import { render, staticRenderFns } from "./m-dialog-iit-sign-plugin.vue?vue&type=template&id=081b04e5&lang=pug&"
import script from "./m-dialog-iit-sign-plugin.vue?vue&type=script&lang=js&"
export * from "./m-dialog-iit-sign-plugin.vue?vue&type=script&lang=js&"
import style0 from "./m-dialog-iit-sign-plugin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VOverlay,VRow})
